import { render } from "./dcRingChart.vue?vue&type=template&id=05dc509e"
import script from "./dcRingChart.vue?vue&type=script&lang=js"
export * from "./dcRingChart.vue?vue&type=script&lang=js"

import exportComponent from "/data/jenkins-workspace/workspace/Publicar_automáticamente_por_Lianxin/联心运营后台前端【生产】/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__